module.exports = __webpack_public_path__ + "img/icon-serve2.b44788e1.png";